// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-map-preview {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  background: #0f1822;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);
}
 
.risk-map-preview-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: rgba(15, 24, 34, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  flex-shrink: 0;
}
 
.risk-map-preview-title-group {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
 
.risk-map-preview-title {
  font-size: 16px;
  font-weight: 700;
  color: #eaf0f6;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
 
.risk-map-preview-live {
  font-size: 13px;
  font-weight: 500;
  color: #EE5B43;
  white-space: nowrap;
}
 
/* ── Conteneur de la carte : référence positionnelle pour le timeline ── */
.risk-map-preview-map {
  flex: 1 1;
  min-height: 0;
  position: relative;
}
 
.risk-map-preview-map > .map-preview-wrapper {
  width: 100% !important;
  height: 100% !important;
}
 
/* ── Overlay timeline : bas de la carte, centré ── */
.risk-map-preview-timeline-overlay {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
}
 
.risk-map-preview-timeline-overlay > * {
  pointer-events: auto;
}
 
/* Le ForecastTimeline a son propre position:absolute avec bottom/left/
   transform pensés pour le plein écran ; on neutralise uniquement ces
   valeurs de positionnement (pas le position lui-même) pour qu'il
   s'affiche en flux normal CENTRÉ à l'intérieur de notre wrapper,
   ancré au bas de la carte par le wrapper externe */
.risk-map-preview-timeline-overlay .forecast-timeline-container {
  position: static;
  bottom: auto;
  left: auto;
  transform: none;
  max-width: 100%;
}
 
.risk-map-preview-timeline-overlay .timeline-progress-wrapper {
  width: min(700px, 90vw);
  max-width: 360px;
}
 
.risk-map-preview-legend {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 16px;
  background: rgba(15, 24, 34, 0.95);
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  flex-shrink: 0;
}
 
.risk-map-expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #ccd8e0;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
 
.risk-map-expand-btn svg {
  font-size: 13px;
}
 
.risk-map-expand-btn:hover {
  background: rgba(238, 91, 67, 0.12);
  border-color: #EE5B43;
  color: #EE5B43;
}
 
.legend-item {
  font-size: 16px;
  font-weight: 500;
  color: #ccd8e0;
}
 
.legend-faible   { color: #2e742f; }
.legend-modere   { color: #fdd801; }
.legend-eleve    { color: #ed6204; }
.legend-tres-eleve { color: #e80201; }
 
/* ───────────────────────────────────────────────
   Responsive : console compacte, timeline réduit
   progressivement sur tablette/mobile pour rester
   lisible sans déborder de la carte
─────────────────────────────────────────────── */
 
@media (max-width: 1024px) {
  .risk-map-preview-timeline-overlay {
    bottom: 8px;
  }
}
 
@media (max-width: 768px) {
  .risk-map-preview-timeline-overlay .forecast-timeline-pill {
    transform: scale(0.9);
  }
}
 
@media (max-width: 768px) {
  .risk-map-preview {
    border-radius: 12px;
  }
 
  .risk-map-preview-bar {
    padding: 8px 12px;
  }
 
  .risk-map-preview-title {
    font-size: 14px;
  }
 
  .risk-map-preview-live {
    font-size: 11px;
  }
 
  .risk-map-preview-legend {
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 12px;
    justify-content: center;
  }
 
  .legend-item {
    font-size: 13px;
  }
 
  .risk-map-expand-btn {
    font-size: 12px;
    padding: 4px 10px;
  }
 
  .risk-map-preview-timeline-overlay {
    bottom: 4px;
  }
 
  .risk-map-preview-timeline-overlay .forecast-timeline-pill {
    transform: scale(0.85);
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder {
    width: 100% !important;
    max-width: 200px !important;
    min-width: 140px !important;
    font-size: 13px;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    font-size: 13px !important;
    padding: 6px 30px 6px 10px !important;
    height: 34px !important;
  }
 
  /* Icône loupe masquée sur petit écran pour gagner de la place */
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {
    display: none !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    padding-left: 10px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {
    width: 14px !important;
    height: 14px !important;
    top: 10px !important;
    right: 8px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--button {
    padding: 4px !important;
  }
 
  .mapboxgl-ctrl-geocoder--suggestions {
    font-size: 13px !important;
    max-width: calc(100vw - 32px) !important;
    min-width: 200px !important;
  }
 
  .mapboxgl-ctrl-geocoder--suggestion {
    padding: 8px 12px !important;
    font-size: 13px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-top-right {
    display: flex;
    flex-direction: column;
    gap: 6px;
    top: 8px;
    right: 8px;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-bottom-right {
    bottom: 8px;
    right: 8px;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-group {
    margin: 0 !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl button {
    width: 34px !important;
    height: 34px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-group:not(:last-child) {
    margin-bottom: 4px !important;
  }
}
 
@media (max-width: 480px) {
  .risk-map-preview {
    border-radius: 8px;
  }
 
  .risk-map-preview-bar {
    padding: 6px 10px;
  }
 
  .risk-map-preview-title {
    font-size: 13px;
  }
 
  .risk-map-preview-live {
    font-size: 10px;
  }
 
  .risk-map-preview-title-group {
    gap: 0;
  }
 
  .risk-map-preview-legend {
    gap: 8px;
    padding: 6px 10px;
  }
 
  .legend-item {
    font-size: 12px;
  }
 
  .risk-map-expand-btn {
    font-size: 11px;
    padding: 3px 8px;
    gap: 4px;
  }
 
  .risk-map-expand-btn svg {
    font-size: 11px;
  }
 
  .risk-map-preview-timeline-overlay {
    bottom: 2px;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder {
    max-width: 140px !important;
    min-width: 100px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    font-size: 12px !important;
    padding: 4px 26px 4px 8px !important;
    height: 30px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {
    display: none !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    padding-left: 8px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {
    width: 12px !important;
    height: 12px !important;
    top: 9px !important;
    right: 6px !important;
  }
 
  .mapboxgl-ctrl-geocoder--suggestions {
    font-size: 12px !important;
    min-width: 160px !important;
  }
 
  .mapboxgl-ctrl-geocoder--suggestion {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }
 
  .map-preview-wrapper .mapboxgl-ctrl button {
    width: 30px !important;
    height: 30px !important;
  }
}
 
@media (max-width: 424px) {
  .risk-map-preview-title-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }
}
 
@media (max-width: 360px) {
  .risk-map-preview-timeline-overlay {
    bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/RiskMapPreview/RiskMapPreview.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;oDAIoD;AACpD;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yEAAyE;AAC3E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,qBAAqB,cAAc,EAAE;;AAErC;;;;iDAIiD;;AAEjD;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA,gEAAgE;EAChE;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".risk-map-preview {\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #0f1822;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);\n}\n \n.risk-map-preview-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: rgba(15, 24, 34, 0.95);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  flex-shrink: 0;\n}\n \n.risk-map-preview-title-group {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n \n.risk-map-preview-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #eaf0f6;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n \n.risk-map-preview-live {\n  font-size: 13px;\n  font-weight: 500;\n  color: #EE5B43;\n  white-space: nowrap;\n}\n \n/* ── Conteneur de la carte : référence positionnelle pour le timeline ── */\n.risk-map-preview-map {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n \n.risk-map-preview-map > .map-preview-wrapper {\n  width: 100% !important;\n  height: 100% !important;\n}\n \n/* ── Overlay timeline : bas de la carte, centré ── */\n.risk-map-preview-timeline-overlay {\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  pointer-events: none;\n}\n \n.risk-map-preview-timeline-overlay > * {\n  pointer-events: auto;\n}\n \n/* Le ForecastTimeline a son propre position:absolute avec bottom/left/\n   transform pensés pour le plein écran ; on neutralise uniquement ces\n   valeurs de positionnement (pas le position lui-même) pour qu'il\n   s'affiche en flux normal CENTRÉ à l'intérieur de notre wrapper,\n   ancré au bas de la carte par le wrapper externe */\n.risk-map-preview-timeline-overlay .forecast-timeline-container {\n  position: static;\n  bottom: auto;\n  left: auto;\n  transform: none;\n  max-width: 100%;\n}\n \n.risk-map-preview-timeline-overlay .timeline-progress-wrapper {\n  width: min(700px, 90vw);\n  max-width: 360px;\n}\n \n.risk-map-preview-legend {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 10px 16px;\n  background: rgba(15, 24, 34, 0.95);\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n  flex-shrink: 0;\n}\n \n.risk-map-expand-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ccd8e0;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n \n.risk-map-expand-btn svg {\n  font-size: 13px;\n}\n \n.risk-map-expand-btn:hover {\n  background: rgba(238, 91, 67, 0.12);\n  border-color: #EE5B43;\n  color: #EE5B43;\n}\n \n.legend-item {\n  font-size: 16px;\n  font-weight: 500;\n  color: #ccd8e0;\n}\n \n.legend-faible   { color: #2e742f; }\n.legend-modere   { color: #fdd801; }\n.legend-eleve    { color: #ed6204; }\n.legend-tres-eleve { color: #e80201; }\n \n/* ───────────────────────────────────────────────\n   Responsive : console compacte, timeline réduit\n   progressivement sur tablette/mobile pour rester\n   lisible sans déborder de la carte\n─────────────────────────────────────────────── */\n \n@media (max-width: 1024px) {\n  .risk-map-preview-timeline-overlay {\n    bottom: 8px;\n  }\n}\n \n@media (max-width: 768px) {\n  .risk-map-preview-timeline-overlay .forecast-timeline-pill {\n    transform: scale(0.9);\n  }\n}\n \n@media (max-width: 768px) {\n  .risk-map-preview {\n    border-radius: 12px;\n  }\n \n  .risk-map-preview-bar {\n    padding: 8px 12px;\n  }\n \n  .risk-map-preview-title {\n    font-size: 14px;\n  }\n \n  .risk-map-preview-live {\n    font-size: 11px;\n  }\n \n  .risk-map-preview-legend {\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 8px 12px;\n    justify-content: center;\n  }\n \n  .legend-item {\n    font-size: 13px;\n  }\n \n  .risk-map-expand-btn {\n    font-size: 12px;\n    padding: 4px 10px;\n  }\n \n  .risk-map-preview-timeline-overlay {\n    bottom: 4px;\n  }\n \n  .risk-map-preview-timeline-overlay .forecast-timeline-pill {\n    transform: scale(0.85);\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder {\n    width: 100% !important;\n    max-width: 200px !important;\n    min-width: 140px !important;\n    font-size: 13px;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    font-size: 13px !important;\n    padding: 6px 30px 6px 10px !important;\n    height: 34px !important;\n  }\n \n  /* Icône loupe masquée sur petit écran pour gagner de la place */\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {\n    display: none !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    padding-left: 10px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {\n    width: 14px !important;\n    height: 14px !important;\n    top: 10px !important;\n    right: 8px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--button {\n    padding: 4px !important;\n  }\n \n  .mapboxgl-ctrl-geocoder--suggestions {\n    font-size: 13px !important;\n    max-width: calc(100vw - 32px) !important;\n    min-width: 200px !important;\n  }\n \n  .mapboxgl-ctrl-geocoder--suggestion {\n    padding: 8px 12px !important;\n    font-size: 13px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-top-right {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    top: 8px;\n    right: 8px;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-bottom-right {\n    bottom: 8px;\n    right: 8px;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-group {\n    margin: 0 !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl button {\n    width: 34px !important;\n    height: 34px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-group:not(:last-child) {\n    margin-bottom: 4px !important;\n  }\n}\n \n@media (max-width: 480px) {\n  .risk-map-preview {\n    border-radius: 8px;\n  }\n \n  .risk-map-preview-bar {\n    padding: 6px 10px;\n  }\n \n  .risk-map-preview-title {\n    font-size: 13px;\n  }\n \n  .risk-map-preview-live {\n    font-size: 10px;\n  }\n \n  .risk-map-preview-title-group {\n    gap: 0;\n  }\n \n  .risk-map-preview-legend {\n    gap: 8px;\n    padding: 6px 10px;\n  }\n \n  .legend-item {\n    font-size: 12px;\n  }\n \n  .risk-map-expand-btn {\n    font-size: 11px;\n    padding: 3px 8px;\n    gap: 4px;\n  }\n \n  .risk-map-expand-btn svg {\n    font-size: 11px;\n  }\n \n  .risk-map-preview-timeline-overlay {\n    bottom: 2px;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder {\n    max-width: 140px !important;\n    min-width: 100px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    font-size: 12px !important;\n    padding: 4px 26px 4px 8px !important;\n    height: 30px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {\n    display: none !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    padding-left: 8px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {\n    width: 12px !important;\n    height: 12px !important;\n    top: 9px !important;\n    right: 6px !important;\n  }\n \n  .mapboxgl-ctrl-geocoder--suggestions {\n    font-size: 12px !important;\n    min-width: 160px !important;\n  }\n \n  .mapboxgl-ctrl-geocoder--suggestion {\n    padding: 6px 10px !important;\n    font-size: 12px !important;\n  }\n \n  .map-preview-wrapper .mapboxgl-ctrl button {\n    width: 30px !important;\n    height: 30px !important;\n  }\n}\n \n@media (max-width: 424px) {\n  .risk-map-preview-title-group {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1px;\n  }\n}\n \n@media (max-width: 360px) {\n  .risk-map-preview-timeline-overlay {\n    bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
